import { FunctionComponent } from "react";
import { SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";

import * as Styled from "./styles";

import "swiper/css";
import "swiper/css/autoplay";
import { Spacing } from "../Containers";

export type Testimony = {
  content: string;
  name: string;
  subtitle?: string;
};

interface TestimonyCarouselProps {
  testimonies: Testimony[];
}

const TestimonyCarousel: FunctionComponent<TestimonyCarouselProps> = ({ testimonies }: TestimonyCarouselProps) => {
  return (
    <Styled.SwiperDiv
      slidesPerView="auto"
      centeredSlides
      autoplay={{
        delay: 4000,
        disableOnInteraction: false,
      }}
      modules={[Autoplay]}
      speed={2000}
      loop
    >
      {testimonies.map((testimony) => (
        <SwiperSlide key={`${testimony.name}-1`}>
          <Styled.TestimonySlide>
            <Styled.TestimonySlideWrapper>
              <div>
                <svg width="27" height="18" viewBox="0 0 27 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M0.0105655 11.5733C0.00804989 11.6427 0 11.7106 0 11.7811C0 11.8047 0.00301871 11.8274 0.00352183 11.8505C0.00301871 11.8968 0 11.9426 0 11.9889L0.0100627 11.9818C0.116724 15.0841 2.65899 17.568 5.7869 17.568C8.98273 17.568 11.5738 14.9774 11.5738 11.7811C11.5738 8.865 9.4144 6.45957 6.6085 6.05959C7.30582 3.74775 9.44862 2.06582 11.9894 2.06582V0C5.50264 0.000503121 0.229926 5.14039 0.0105655 11.5733Z"
                    fill="#2E2D29"
                    fillOpacity="0.9"
                  />
                  <path
                    d="M15.0223 11.5733C15.0198 11.6427 15.0117 11.7106 15.0117 11.7811C15.0117 11.8047 15.0152 11.8274 15.0152 11.8505C15.0147 11.8968 15.0117 11.9426 15.0117 11.9889L15.0223 11.9818C15.1289 15.0841 17.6712 17.568 20.7986 17.568C23.9949 17.568 26.5855 14.9774 26.5855 11.7811C26.5855 8.865 24.4261 6.45957 21.6202 6.05959C22.3175 3.74775 24.4603 2.06582 27.0006 2.06582V0C20.5139 0.000503121 15.2422 5.14039 15.0223 11.5733Z"
                    fill="#2E2D29"
                    fillOpacity="0.9"
                  />
                </svg>
                <Spacing $mobileSpace={18} $laptopSpace={15} />
              </div>
              <Styled.TestimonySlideContent>
                <p>"{testimony.content}"</p>
              </Styled.TestimonySlideContent>
              <Styled.TestimonySlideName>
                <p>{testimony.name}</p>
                {testimony.subtitle && <p className="secondary">{testimony.subtitle}</p>}
              </Styled.TestimonySlideName>
            </Styled.TestimonySlideWrapper>
          </Styled.TestimonySlide>
        </SwiperSlide>
      ))}
      {testimonies.map((testimony) => (
        <SwiperSlide key={`${testimony.name}-2`}>
          <Styled.TestimonySlide>
            <Styled.TestimonySlideWrapper>
              <div>
                <svg width="27" height="18" viewBox="0 0 27 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M0.0105655 11.5733C0.00804989 11.6427 0 11.7106 0 11.7811C0 11.8047 0.00301871 11.8274 0.00352183 11.8505C0.00301871 11.8968 0 11.9426 0 11.9889L0.0100627 11.9818C0.116724 15.0841 2.65899 17.568 5.7869 17.568C8.98273 17.568 11.5738 14.9774 11.5738 11.7811C11.5738 8.865 9.4144 6.45957 6.6085 6.05959C7.30582 3.74775 9.44862 2.06582 11.9894 2.06582V0C5.50264 0.000503121 0.229926 5.14039 0.0105655 11.5733Z"
                    fill="#2E2D29"
                    fillOpacity="0.9"
                  />
                  <path
                    d="M15.0223 11.5733C15.0198 11.6427 15.0117 11.7106 15.0117 11.7811C15.0117 11.8047 15.0152 11.8274 15.0152 11.8505C15.0147 11.8968 15.0117 11.9426 15.0117 11.9889L15.0223 11.9818C15.1289 15.0841 17.6712 17.568 20.7986 17.568C23.9949 17.568 26.5855 14.9774 26.5855 11.7811C26.5855 8.865 24.4261 6.45957 21.6202 6.05959C22.3175 3.74775 24.4603 2.06582 27.0006 2.06582V0C20.5139 0.000503121 15.2422 5.14039 15.0223 11.5733Z"
                    fill="#2E2D29"
                    fillOpacity="0.9"
                  />
                </svg>
                <Spacing $mobileSpace={26} $laptopSpace={33} />
              </div>
              <Styled.TestimonySlideContent>
                <p>"{testimony.content}"</p>
              </Styled.TestimonySlideContent>
              <Styled.TestimonySlideName>
                <p>{testimony.name}</p>
                {testimony.subtitle && <p className="secondary">{testimony.subtitle}</p>}
              </Styled.TestimonySlideName>
            </Styled.TestimonySlideWrapper>
          </Styled.TestimonySlide>
        </SwiperSlide>
      ))}
    </Styled.SwiperDiv>
  );
};

export default TestimonyCarousel;
